<template>
  <div class="wecoupon-mall-content" :style="bgStyle" v-if="isHasData">
    <div class="top" v-on:click="handleGoSpChannel"></div>
    <Info :data="mallInfo"></Info>
    <List :id="spid" @beforeCompleted="$emit('beforeCompleted')" @afterCompleted="handleAfterCompleted"
      @couponBtnClick="$emit('couponBtnClick')"></List>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue-demi';
import { windowHelper } from '@tencent/ppd-base-libs';
import Info from './info.vue';
import List from './list/index.vue';
import { useMall } from '../hooks/use-mall';

export default defineComponent({
  name: 'MallContent',
  components: {
    Info,
    List,
  },
  emits: ['beforeCompleted', 'afterCompleted', 'couponBtnClick'],
  setup(props, context) {
    const { currMallInfo } = useMall();
    const isHasData = computed(() => !!currMallInfo.value);

    const mallInfo = computed(() => {
      const { id, name, desc, addr } = currMallInfo.value || {};
      return { id, name, desc, addr };
    });

    const spid = computed(() => mallInfo.value.id || '');

    const bgStyle = computed(() => {
      const { value } = currMallInfo;
      if (!value) return {};

      const { bgImgUrl, bgColor } = value;
      return {
        backgroundImage: `url(${bgImgUrl})`,
        backgroundColor: bgColor,
      };
    });

    function handleAfterCompleted(id: string) {
      context.emit('afterCompleted', id);
    }

    function handleGoSpChannel() {
      const url = `//prom.wechatpay.com.hk/merchant-channel/index.shtml?ADTAG=mall&spId=${encodeURIComponent(mallInfo.value.id || '')}`;
      windowHelper.redirect(url);
    }

    return {
      spid,
      isHasData,
      mallInfo,
      bgStyle,
      handleGoSpChannel,
      handleAfterCompleted,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../less/main.less';

.wecoupon-mall-content {
  background-color: #c4c4c4;
  border-radius: 12 / @rem;
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 0 28 / @rem 28 / @rem 28 / @rem;

  .top {
    height: 129 / @rem;
  }
}
</style>
